import { generatePath } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as ROUTES from '#client/constants/routes';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function AssistanceSection() {
  const { productConfig } = useProductLandingContext();
  const { assistance } = productConfig;

  return (
    <Stack gap={4} marginBlockStart={4}>
      <Heading component="h2" size="xl" wrap="wrap">
        <FormattedMessage id={assistance.title} />
      </Heading>
      <Link
        href={generatePath(ROUTES.help)}
        target="_blank"
        sx={{ textDecoration: 'none' }}
      >
        <Card sx={{ padding: 2 }}>
          <Stack gap={2} direction="row" alignItems="center" sx={{ marginBottom: '0.75rem' }}>
            <Box width={{ xs: '1.375rem', md: '2rem' }} height={{ xs: '1.375rem', md: '2rem' }}>
              <SharedAsset alt="icon" src="/s2/material-icons/assistantrounded.svg" width="100%" height="100%" />
            </Box>
            <Text size="md" weight="medium" color="secondary"><FormattedMessage id={assistance.getInTouch} /></Text>
          </Stack>
          <Text
            size="sm"
            color="blue"
            weight="medium"
          >
            <FormattedMessage id={assistance.actions} />
          </Text>
        </Card>
      </Link>
    </Stack>
  );
}

export default AssistanceSection;
